import styled, {css} from "styled-components"

interface ReadMoreToggleProps {
  isRequired: boolean
  isOpen: boolean
}

const readMoreCss = css<ReadMoreToggleProps>`
  .readMore {
    display: block;
    text-align: center;
    padding-top: 1.5em;
    font-family: ${({theme}) => theme.font.default};
    text-transform: uppercase;
    font-size: 10px;
    font-weight: bold;
    line-height: 12px;
    cursor: pointer;
  }

  .readMore_constraint {
    display: block;
    overflow: hidden;
    transition: max-height 0.3s;

    ${({isRequired}) => css`
      ${isRequired &&
      css`
        -webkit-mask-image: -webkit-gradient(linear, 0% 75%, 0% 100%, from(rgba(0, 0, 0, 1)), to(rgba(0, 0, 0, 0)));
        mask-image: -webkit-gradient(linear, 0% 75%, 0% 100%, from(rgba(0, 0, 0, 1)), to(rgba(0, 0, 0, 0)));
      `}
    `}

    ${({isOpen}) =>
      isOpen &&
      css`
        cursor: pointer;
        -webkit-mask-image: none;
        mask-image: none;
      `}
  }
`

export const Container = styled.div`
  ${readMoreCss}
`
